export const money = (v) => (v == null ? "-" : `£${Number(v).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const day = (s) => (s ? new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-");

export const Panel = ({ title, children, testid, right }) => (
  <section className="rounded-3xl border border-slate-200 bg-white p-6" data-testid={testid}>
    {title && <div className="mb-4 flex items-center justify-between gap-3"><h2 className="font-display text-lg font-bold">{title}</h2>{right}</div>}
    {children}
  </section>
);

export const Stat = ({ label, value, sub, testid }) => (
  <div className="rounded-3xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</p>
    <p className="mt-1 font-display text-3xl font-extrabold">{value}</p>
    {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
  </div>
);

export const Table = ({ cols, rows, testid, empty = "Nothing yet." }) => (
  <div className="overflow-x-auto" data-testid={testid}>
    <table className="w-full text-sm">
      <thead><tr>{cols.map(([k, l]) => <th key={k} className="border-b border-slate-200 px-2 py-2 text-left text-xs font-bold uppercase tracking-wider text-slate-500">{l}</th>)}</tr></thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={cols.length} className="px-2 py-6 text-center text-slate-400">{empty}</td></tr>}
        {rows.map((r, i) => <tr key={r.id || r.code || i} className="border-b border-slate-100 last:border-0">{cols.map(([k, , f]) => <td key={k} className="px-2 py-2.5 align-top">{f ? f(r) : r[k] ?? "-"}</td>)}</tr>)}
      </tbody>
    </table>
  </div>
);

const HEALTH = { green: "bg-emerald-100 text-emerald-800", amber: "bg-amber-100 text-amber-800", red: "bg-rose-100 text-rose-800" };
export const Health = ({ h }) => <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${HEALTH[h] || "bg-slate-100"}`}>{h || "-"}</span>;
